import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';

interface ContainerCardProps {
	hasMargin?: boolean;
}

export const WrapperEmpty = styled.div`
	display: grid;
	grid-template-rows: 212px 1fr;
	background-color: white;
	width: 100%;
	height: calc(100vh - 140px);
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	max-width: 528px;
	margin: 48px auto 80px auto;
	height: 84px;
`;

export const ContainerEmpty = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #f5f7fa;
	height: calc(100vh - 400px);
	width: calc(100% - 124px);
	margin: 0 auto;

	.megaphone-icon {
		& > path {
			fill: #5082c2;
		}
	}
`;

export const ContainerFilters = styled.form`
	display: flex;
	flex-direction: column;
	padding: 20px 0;
`;

export const Filters = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
`;

export const ContainerLoading = styled.div`
	display: grid;
	place-items: center;
	height: 200px;
`;

export const ContainerButton = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 20px;
	margin-bottom: 24px;
`;

export const Container = styled.div`
	background-color: white;
	padding: 48px 20px;
`;

export const WrapperLoading = styled.div`
	display: flex;
	flex-direction: column;
	background-color: white;
	height: calc(100vh - 140px);
	padding: 50px 20px;

	.title {
		div:first-child {
			background-color: #a7c1e1;
		}
	}
`;

export const Title = styled.h2`
	font-weight: 700;
	font-family: 'Montserrat';
	font-size: 20px;
	color: ${tokens.color_primary};
	text-align: center;
	margin-bottom: 24px;
`;

export const Subtitle = styled.h3`
	font-weight: 500;
	font-family: 'Montserrat';
	font-size: 18px;
	color: ${tokens.color_gray_dark};
	text-align: center;
	padding: 24px 0 32px 0;
	max-width: 530px;
	margin: 0 auto;
`;

export const Text = styled.p`
	font-weight: 500;
	font-family: 'Montserrat';
	font-size: 18px;
	color: ${tokens.color_gray_dark};
	text-align: center;
	padding: 32px 0;
`;

export const ContainerCard = styled.div<ContainerCardProps>`
	margin-top: ${({ hasMargin }) => hasMargin && '42px'};
	display: grid;
	row-gap: 100px;
	grid-template-columns: 1fr 1fr 1fr;
	justify-content: center;
	align-items: center;
	padding: 48px 0;
	height: 50vh;
	overflow-y: auto;
	box-sizing: border-box;

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background: #888;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}

	@media (max-width: 1500px) {
		grid-template-columns: 1fr 1fr 1fr;
	}

	@media (max-width: 1250px) {
		grid-template-columns: 1fr 1fr;
	}

	@media (max-width: 880px) {
		grid-template-columns: 1fr;
	}
`;

export const EmptyContainerButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;

	@media (max-width: 1500px) {
		margin-bottom: 24px;
	}
`;

export const SkeletonTextContainer = styled.div<{ loading?: boolean }>`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	padding: 12px;

	${({ loading }) =>
		loading &&
		css`
			div:first-child {
				background: linear-gradient(
						110deg,
						rgb(167, 193, 225) 8%,
						rgb(211, 224, 240) 18%,
						rgb(167, 193, 225) 33%
					)
					0% 0% / 200% 100%;
				opacity: 0.5;
			}
		`};
`;

export const WarningText = styled.p``;

export const WarningAction = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	margin-top: 30px;
`;

export const LayoutPage = styled.div`
	padding: 30px;
	display: flex;
	flex-direction: column;
`;
